import AtomSpinner, {atomSpinnerOverlayTypes, atomSpinnerTypes} from '@s-ui/react-atom-spinner'

import Loader from './LoaderSpinner.js'

const SpinnerSellerPlate = () => {
  return (
    <AtomSpinner overlayType={atomSpinnerOverlayTypes.PRIMARY} type={atomSpinnerTypes.FULL}>
      <Loader />
    </AtomSpinner>
  )
}

SpinnerSellerPlate.displayName = 'SpinnerSellerPlate'

export default SpinnerSellerPlate
